import React from 'react';
import PropTypes from 'prop-types';

/**
 * FontPreview - Displays font sample with actual typeface
 */
function FontPreview({ font, isSelected, isLocked, onClick }) {
  const handleClick = () => {
    if (!isLocked) {
      onClick(font.id);
    }
  };

  return (
    <button
      className={`font-preview ${isSelected ? 'selected' : ''} ${isLocked ? 'locked' : ''}`}
      onClick={handleClick}
      disabled={isLocked}
      title={isLocked ? 'Upgrade to Pro for this font' : font.description}
    >
      <div
        className="font-preview-text"
        style={{ fontFamily: `'${font.family}', sans-serif`, fontWeight: 700 }}
      >
        Aa
      </div>
      <div className="font-preview-name">
        {font.name}
      </div>
      {isLocked && (
        <div className="font-preview-lock">
          <i className="fas fa-lock"></i>
        </div>
      )}
    </button>
  );
}

FontPreview.propTypes = {
  font: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    family: PropTypes.string.isRequired,
    tier: PropTypes.oneOf(['core', 'pro']).isRequired,
    description: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  isLocked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default FontPreview;
